/**
 * Простая регистрация Service Worker для автообновления PWA
 */
export const registerServiceWorker = () => {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker
            .register('/sw.js', {
                updateViaCache: 'none', // Всегда проверяем обновления
            })
            .then((reg) => {
                // Проверяем обновления при загрузке
                reg.update();

                // При обнаружении нового Service Worker - перезагружаем страницу
                reg.addEventListener('updatefound', () => {
                    const newWorker = reg.installing;
                    if (newWorker) {
                        newWorker.addEventListener('statechange', () => {
                            if (newWorker.state === 'activated') {
                                window.location.reload();
                            }
                        });
                    }
                });
            })
            .catch((error) => {
                console.error('Service Worker registration failed:', error);
            });

        // При смене контроллера перезагружаем страницу
        navigator.serviceWorker.addEventListener('controllerchange', () => {
            window.location.reload();
        });
    }
};

export const unregisterServiceWorker = () => {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then((registration) => {
            registration.unregister();
        });
    }
};
